import { customAlphabet } from 'nanoid';

import { NANO_ID_ALPHABET, NANO_ID_LENGTH } from 'global/constants';

export default function customNanoId() {
  return customAlphabet(NANO_ID_ALPHABET, NANO_ID_LENGTH)();
}
